import * as yup from 'yup'

export interface FormValues {
  email: string
}

export const schema: FormValues = {
  email: ''
}

export const validation = yup
  .object()
  .shape({
    email: yup
      .string()
      .email('Enter a valid email address')
      .required('Enter an email address')
  })
